import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

// マイナンバー(本人・家族)の編集を fetch で行う。
// - 本人番号編集: #my-mynumber の中身を差し替え(インライン)。
// - 家族番号編集: #modal-mynumber を差し替えてモーダル表示。
// - 家族番号フォーム送信: 空レスポンス=成功でリロード、本文あり=バリデーションエラーで再表示。
export default class extends Controller {
  editMyNumber(event) {
    event.preventDefault();
    this.fetchHtml(event.currentTarget.href).then((html) => {
      document.getElementById('my-mynumber').innerHTML = html;
    });
  }

  editFamilyNumber(event) {
    event.preventDefault();
    this.fetchHtml(event.currentTarget.href).then((html) => this.replaceModal(html));
  }

  submitForm(event) {
    event.preventDefault();
    const form = event.currentTarget;
    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((response) => response.text())
      .then((html) => {
        if (html.trim() === '') {
          window.location.reload();
        } else {
          this.replaceModal(html);
        }
      });
  }

  fetchHtml(url) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((response) => response.text());
  }

  replaceModal(html) {
    const current = document.getElementById('modal-mynumber');
    if (!current) { return; }
    current.outerHTML = html;
    const next = document.getElementById('modal-mynumber');
    if (next) { Modal.getOrCreateInstance(next).show(); }
  }
}
